import {createRouter,createWebHistory} from "vue-router";
import ComplaintForm from "@/components/ComplaintForm.vue";
import ComplaintView from "@/components/ComplaintView.vue";
import DetailsView from "@/components/DetailsView.vue";
import CustomerInfo from "@/components/CustomerInfo.vue";
import CustomerQuery from "@/components/CustomerQuery.vue";
import CustomerRevise from "@/components/CustomerRevise.vue";
import NbFamousOwner from "@/components/NbFamousOwner.vue";
import QdFamousOwner from "@/components/QdFamousOwner.vue";
import MzpxNbQuestions from "@/components/MzpxNbQuestions.vue";
import MzpxQdQuestions from "@/components/MzpxQdQuestions.vue";
import MzpxUsers from "@/components/MzpxUsers.vue";
import CheckIn from "@/components/CheckIn.vue";
import CheckInDetail from "@/components/CheckInDetail.vue";
import testVue from "@/components/testVue.vue";

const router = createRouter({
    history:createWebHistory("/lj/front/"),
    routes : [
        { path : '/',component: ComplaintForm},
        { path : '/ComplaintForm',name : 'ComplaintForm',component: ComplaintForm},
        { path : '/ComplaintView',name : 'ComplaintView',component: ComplaintView},
        { path : '/DetailsView',name : 'DetailsView',component: DetailsView},
        { path : '/CustomerInfo',name : 'CustomerInfo',component: CustomerInfo},
        { path : '/CustomerQuery',name : 'CustomerQuery',component: CustomerQuery},
        { path : '/CustomerRevise',name : 'CustomerRevise',component: CustomerRevise},
        { path : '/NbMzpx',name : 'NbFamousOwner',component: NbFamousOwner},
        { path : '/QdMzpx',name : 'QdFamousOwner',component: QdFamousOwner},
        { path : '/MzpxNbQuestions',name : 'MzpxNbQuestions',component: MzpxNbQuestions},
        { path : '/MzpxQdQuestions',name : 'MzpxQdQuestions',component: MzpxQdQuestions},
        { path : '/MzpxUsers',name : 'MzpxUsers',component: MzpxUsers},
        { path : '/CheckIn',name : 'CheckIn',component: CheckIn},
        { path : '/CheckInDetail/:id',name : 'CheckInDetail',component: CheckInDetail},
        { path : '/testVue',name : 'testVue',component: testVue}
    ]
})
export  default router
